const DISCOVERY_ANALYTICS_KEY = 'rastyle_discovery_analytics_v1';

const buildDiscoverySearchQuery = (action = {}, media = {}) => {
  switch (action.id) {
    case 'artist':
      return media.artist || media.title || '';
    case 'similar':
      return media.genre || media.artist || 'reggae';
    case 'mixes':
      return `${media.artist || media.genre || 'reggae'} mixtape`.trim();
    case 'schedule':
      return 'Rastyle Radio schedule';
    case 'request':
      return 'request a song';
    case 'discussion':
      return `${media.title || 'Rastyle Radio'} discussion`;
    default:
      return action.title || media.title || '';
  }
};

const toRecommendationSeed = (media = {}) => ({
  track_id: String(media.id || media.externalUrl || ''),
  track_type: media.isYouTube ? 'youtube' : 'mixtape',
  title: media.title || '',
  artist: media.artist || 'Rastyle',
  cover: media.cover || '',
  duration: Number(media.duration) || 0,
  genre: media.genre || '',
  mood: media.mood || '',
  url: media.externalUrl || '',
  youtube_id: media.isYouTube ? media.id : '',
  stream_url: !media.isYouTube ? media.externalUrl : '',
});

const recordDiscoveryEvent = (event, payload = {}) => {
  const entry = { event, ...payload, at: new Date().toISOString() };
  try {
    const previous = JSON.parse(localStorage.getItem(DISCOVERY_ANALYTICS_KEY) || '[]');
    localStorage.setItem(DISCOVERY_ANALYTICS_KEY, JSON.stringify([...previous, entry].slice(-250)));
  } catch {
    // Discovery analytics must never interrupt playback.
  }
  try {
    window.dispatchEvent(new CustomEvent('rastyle:discovery-analytics', { detail: entry }));
  } catch {
    // Browser event dispatch is best effort.
  }
  return entry;
};

export {
  DISCOVERY_ANALYTICS_KEY,
  buildDiscoverySearchQuery,
  recordDiscoveryEvent,
  toRecommendationSeed,
};
